/*************************************************
 * VirtuOwl
 * sessionStorage.js
 * Copyright © 2019 concertcare. All rights reserved.
 *************************************************/

let engine = require('store/src/store-engine');
let storetypes = [require('store/storages/sessionStorage')];

let storeplugins = [require('store/plugins/defaults')];
export default engine.createStore(storetypes, storeplugins);
